// Port of api/fuel/app/classes/insights/games/ratings.php

import Segment from 'offline/insights/segment'
import Game from 'offline/model/game'
import Rating from 'offline/model/rating'

export default Segment.extend({
	name: 'ratings',
	insight: false,
	default_: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var gameId = vars.id
		var game = Game.with_id(gameId)

		if (!game) return {}

		var ratings = Rating.filter({
			arrayed: true,
			where: [
				['game_id', '=', game.get_id()],
				['user_id', 'in', userIndex]
			],
			order: {
				rating_value: 'DESC'
			}
		})

		var users = []

		for (var i = 0; i < ratings.length; i++) {
			users.push({
				id: parseInt(ratings[i].user_id, 10),
				rating: parseFloat(ratings[i].rating_value)
			})

			this._references.users.push(parseInt(ratings[i].user_id, 10))
		}

		return {
			users: users,
			game: game.get_name()
		}
	}
})
